export const colors = {
  // standardized colors
  // WHITE
  WHITE: '#FFFFFF',
  // UI GREYS
  BLACK: '#333333',
  G4: '#565656',
  G3: '#888888',
  G2: '#D3D3D3',
  G1: '#EBEBEB',
  // AL RED
  ALR1: '#F20902',
  ALR2: '#CC0000',
  // AL BLUE
  ALB1: '#4E95D8',
  ALB2: '#2D76BC',
  // AL GREEN
  ALG1: '#009F30',
  ALG2: '#04852B',
  // AL YELLOW
  ALY1: '#EFB800',
  ALY2: '#D8A808',

  // outlier colors
  LEGACYGREEN: '#EDF9E8',
  GOOGLE: '#D84E3F',
  FACEBOOK: '#3B5998',
};

export const fonts = {
  default: "'Titillium Web', 'Helvetica', 'Arial', 'sans-serif'",
};

export const screen = {
  mobileMax: '480px',
  xsMin: '481px',
  xsMax: '767px',
  smMin: '768px',
  srpDesktop: '850px',
  smMax: '991px',
  mdMin: '992px',
  srpLrDesktop: '1156px',
  mdMax: '1199px',
  lgMin: '1200px',
};

export default { colors, fonts, screen };
